<app-title-section></app-title-section>
<!-- Navigation Tabs -->
<div class="card " style="margin-left: 15px; margin-right: 15px;min-height:100vh;padding-top: 24px">
    <!-- Tabs -->
    <ul class=" nav nav-tabs m-0" style="border-bottom: 1px solid #eee;">
        <li class="nav-item">
            <a
                    class="nav-link"
                    style="padding-left: 20px"
                    routerLink="/tiers/clients/actif"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    href="javascript:void(0)"
            >
                Actif ({{ activeClientCount }})
            </a>
        </li>
        <li class="nav-item">
            <a
                    class="nav-link"
                    style="padding-left: 20px"
                    routerLink="/tiers/clients/archivé"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    href="javascript:void(0)"
            >
                Archivé ({{ archivedClientCount }})
            </a>
        </li>
    </ul>

    <div class="flex-grow-1 ">
        <router-outlet></router-outlet>
    </div>
</div>

<!-- Hidden File Input -->
<input #fileInput type="file" class="form-control d-none" (change)="onFileSelected($event)" accept=".xlsx" />

<!-- Import Modal -->
<ng-template #importModal let-modal>
    <div class="modal-header" style="background-color: transparent;">
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body justify-content-center align-items-center p-0" style="margin: 30px 170px 64px">
        <h3 class="modal-title" style="text-align: center;">Importer fichier</h3>
        <p style="text-align: center; margin-top: 12px;">Ajoutez un fichier depuis votre appareil.</p>
        <!-- Step 1: Template Download -->
        <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex">
                <button type="button" class="number-button" >1</button>
                <p style="margin-top: 12px; margin-left: 12px;">Télécharger un fichier vide</p>
            </div>
            <button class="btn btn-primary btn-sm d-flex align-items-center justify-content-center "
                    style="width: 30px; height: 30px; padding: 0;justify-self: right"
                    (click)="downloadTemplate()">
                <i data-feather="download" class="feather-icon"></i>
            </button>
        </div>
        <!-- Step 2 -->
        <div class="d-flex align-items-center" style="margin-top: 32px;">
            <button type="button" class="number-button" >2</button>
            <p style="margin-top: 12px; margin-left: 12px;">Validez ou cliquez pour télécharger</p>
        </div>
        <!-- Step 3: File Selection Area -->
        <div class="step-form" style="margin-top: 32px;">
            <div class="form-section rounded border-style gap-3" (click)="triggerFileInput($event)" style="text-align: center; cursor: pointer;"
                 [ngClass]="{'success-bg': selectedFile}">
                <a *ngIf="!selectedFile" class="action-icon" style="color: rgba(19, 74, 211, 1); width: 20px; height: auto; border-radius: 1px !important; margin-bottom: 20px;">
                    <span data-feather="file"></span>
                </a>
                <a *ngIf="selectedFile" class="action-icon" style="color: rgba(47, 43, 61, 0.9); width: 20px; height: auto; border-radius: 1px !important; margin-bottom: 20px;">
                    <span data-feather="file"></span>
                </a>
                <div *ngIf="selectedFile" class="file-name">{{ selectedFile.name }}</div>
                <h5 *ngIf="!selectedFile" style="margin-top: 12px;">Veuillez valider votre fichier avant de l'importer</h5>
                <h5 *ngIf="selectedFile">Importation prête !</h5>
                <p *ngIf="selectedFile" style="font-size: 13px; font-weight: 500; ">
                    Vous pouvez désormais importer {{ selectedFile.name }}.
                </p>
                <p *ngIf="!selectedFile">
                    (La taille maximale du fichier est de 1 Mo, seuls les fichiers .xlsx sont autorisés.)
                </p>
                <a *ngIf="!selectedFile" class="action-icon" style="color: rgba(19, 74, 211, 1); width: 20px; height: auto; border-radius: 1px !important;">
                    <span data-feather="download" class="large-icon" style="color: #134AD3;"></span>
                </a>
                <a *ngIf="selectedFile" class="action-icon" style="color: rgba(40, 199, 111, 1); width: 20px; height: auto; border-radius: 1px !important;">
                    <span data-feather="check" class="large-icon"></span>
                </a>
            </div>
        </div>
        <div class="d-flex align-items-center" style="margin: 32px 0 24px">
            <button type="button" class="number-button" >3</button>
            <p style="margin: 14px">Commencez le processus</p>
        </div>
        <div class="d-flex align-items-center justify-content-center" style="gap: 16px;">
            <button type="button" class="btn" (click)="modal.dismiss('Cancel click')" style="background: rgba(128, 131, 144, 0.16)">Annuler</button>
            <button type="button" class="btn btn-primary" (click)="importFile(); modal.close('Import click')" [disabled]="!selectedFile">Importer</button>
        </div>
    </div>
</ng-template>

